import { render, staticRenderFns } from "./NavbarEmpresa.vue?vue&type=template&id=b1cfae36&scoped=true"
import script from "./NavbarEmpresa.vue?vue&type=script&lang=js"
export * from "./NavbarEmpresa.vue?vue&type=script&lang=js"
import style0 from "./NavbarEmpresa.vue?vue&type=style&index=0&id=b1cfae36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cfae36",
  null
  
)

export default component.exports